// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".without-data[data-v-26dcdcd0]{height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center}.without-data__img[data-v-26dcdcd0]{width:2.5rem;height:2.5rem}.without-data__text[data-v-26dcdcd0]{margin-top:.2rem;width:100%;line-height:.4rem;text-align:center;font-size:.28rem;color:#a6a6a6}", ""]);
// Exports
module.exports = exports;
